export default __webpack_public_path__ + "static/benefit-1-2c236750b151384f4ebe403b5ecd2da2.webp";